'use client';

import { c as _c } from "react/compiler-runtime";
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import usePartnerSignupEntryPrompt from '@module/helpers/auth/usePartnerSignupEntryPrompt';
import useModalStore from '@module/stores/useModalStore';
import TimeConstants from '@module/utils/item';
import Cookies from 'js-cookie';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { MODAL_TYPE_PC } from '../types/modal/type';
import { checkIsMobile } from '../utils/checkIsMobile';
const AUTH_ELIGIBLE_MODES = ['s', 'c', 'w', 'ad', 'v'] as const;
const DISABLED_PROMPT_DELAY = -1;
export function PartnerComp() {
  const $ = _c(41);
  const router = useRouter();
  const {
    pushModal,
    popModal,
    modal
  } = useModalStore();
  const {
    siteMode,
    isAuthDone,
    isLogin,
    isLoginInfoFetching
  } = useGetLoginInfoQuery();
  let t0;
  if ($[0] !== isLogin || $[1] !== isLoginInfoFetching) {
    t0 = {
      isLogin,
      isLoginInfoFetching
    };
    $[0] = isLogin;
    $[1] = isLoginInfoFetching;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  usePartnerSignupEntryPrompt(t0);
  const mode = siteMode?.mode;
  const [authPromptDelayMs, setAuthPromptDelayMs] = useState(DISABLED_PROMPT_DELAY);
  const location = usePathname();
  const isVirtualMode = mode === "v";
  const isAuthRoute = location === "/my/auth";
  let t1;
  if ($[3] !== location) {
    t1 = location.includes("/user");
    $[3] = location;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const isUserRoute = t1;
  let t2;
  if ($[5] !== isAuthRoute) {
    t2 = () => {
      if (isAuthRoute) {
        return;
      }
      setAuthPromptDelayMs(0);
    };
    $[5] = isAuthRoute;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== isAuthRoute || $[8] !== location) {
    t3 = [location, isAuthRoute];
    $[7] = isAuthRoute;
    $[8] = location;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  useEffect(t2, t3);
  let t4;
  if ($[10] !== isLogin || $[11] !== isUserRoute || $[12] !== isVirtualMode || $[13] !== pushModal) {
    t4 = () => {
      const partnerLogin = Cookies.get("uld_pLogin");
      const shouldPromptVirtual = isVirtualMode && !isUserRoute;
      const shouldPromptPartner = !!partnerLogin && !isVirtualMode;
      const shouldPromptAuth = shouldPromptVirtual || shouldPromptPartner;
      if (!shouldPromptAuth) {
        return;
      }
      const handleAuthTimer = setInterval(() => {
        if (useModalStore.getState().modal.length > 0) {
          return;
        }
        if (isLogin) {
          clearInterval(handleAuthTimer);
          return;
        }
        pushModal({
          type: "AUTH_MODAL",
          id: "PartnerComp - 1",
          options: {
            tab: "register"
          }
        });
      }, TimeConstants.ONE_SECOND * 5);
      return () => {
        clearInterval(handleAuthTimer);
      };
    };
    $[10] = isLogin;
    $[11] = isUserRoute;
    $[12] = isVirtualMode;
    $[13] = pushModal;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== isLogin || $[16] !== isUserRoute || $[17] !== isVirtualMode || $[18] !== modal || $[19] !== pushModal) {
    t5 = [modal, isLogin, isVirtualMode, isUserRoute, pushModal];
    $[15] = isLogin;
    $[16] = isUserRoute;
    $[17] = isVirtualMode;
    $[18] = modal;
    $[19] = pushModal;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  useEffect(t4, t5);
  let t6;
  if ($[21] !== authPromptDelayMs || $[22] !== isAuthDone || $[23] !== isLogin || $[24] !== isLoginInfoFetching || $[25] !== modal.length || $[26] !== mode || $[27] !== popModal || $[28] !== pushModal || $[29] !== router) {
    t6 = () => {
      const isAuthEligibleMode = AUTH_ELIGIBLE_MODES.includes((mode || "") as (typeof AUTH_ELIGIBLE_MODES)[number]);
      const hasPromptDelay = authPromptDelayMs !== DISABLED_PROMPT_DELAY;
      const hasOpenModal = modal.length > 0;
      const shouldSkipPrompt = isLoginInfoFetching || !isLogin || isAuthDone || !isAuthEligibleMode || !hasPromptDelay || hasOpenModal;
      const handleIdentityVerification = () => {
        const isMobile = checkIsMobile();
        if (isMobile) {
          router.push("/my/auth");
          return;
        }
        popModal();
        pushModal({
          id: "PartnerComp - 3",
          type: MODAL_TYPE_PC.IDENTITY_VERIFICATION_MODAL
        });
      };
      if (shouldSkipPrompt) {
        return;
      }
      const timeoutHandler = setTimeout(() => {
        setAuthPromptDelayMs(DISABLED_PROMPT_DELAY);
        if (Cookies.get("introY")) {
          pushModal({
            type: "CONFIRM_CANCEL_MODAL",
            id: "PatnerComp - 2",
            options: {
              description: "\uBCF8\uC778\uC778\uC99D \uD6C4 \uB354 \uB2E4\uC591\uD55C \uCF58\uD150\uCE20\uB97C \uB9CC\uB098\uBCF4\uC138\uC694.",
              onClick: handleIdentityVerification,
              onClose: () => {
                setAuthPromptDelayMs(TimeConstants.ONE_SECOND * 10);
                popModal();
              }
            }
          });
        }
      }, authPromptDelayMs);
      return () => {
        clearTimeout(timeoutHandler);
      };
    };
    $[21] = authPromptDelayMs;
    $[22] = isAuthDone;
    $[23] = isLogin;
    $[24] = isLoginInfoFetching;
    $[25] = modal.length;
    $[26] = mode;
    $[27] = popModal;
    $[28] = pushModal;
    $[29] = router;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  let t7;
  if ($[31] !== authPromptDelayMs || $[32] !== isAuthDone || $[33] !== isLogin || $[34] !== isLoginInfoFetching || $[35] !== modal || $[36] !== mode || $[37] !== popModal || $[38] !== pushModal || $[39] !== router) {
    t7 = [isLogin, isAuthDone, mode, pushModal, popModal, authPromptDelayMs, isLoginInfoFetching, modal, router];
    $[31] = authPromptDelayMs;
    $[32] = isAuthDone;
    $[33] = isLogin;
    $[34] = isLoginInfoFetching;
    $[35] = modal;
    $[36] = mode;
    $[37] = popModal;
    $[38] = pushModal;
    $[39] = router;
    $[40] = t7;
  } else {
    t7 = $[40];
  }
  useEffect(t6, t7);
  return null;
}